<template>
  <div>
    <BarProgressStepper
      class="mx-base mb-twentyFive"
      :total-steps="steps"
      :current-step="step"
      :start-label="$t('bulkSend.start')"
      :end-label="$t('bulkSend.complete')"
    />

    <NamePage />
  </div>
</template>

<script>
import { useBulkSendStepsProgress } from '@/composables/bulkSend/steps';

import NamePage from '@/components/pages/bulkSend/NamePage.vue';
import BarProgressStepper from '@/components/library/progressSteppers/BarProgressStepper/BarProgressStepper.vue';
import { defineComponent, onBeforeMount } from 'vue';
import { useActions } from 'vuex-composition-helpers/dist';

export default defineComponent({
  name: 'CreatePage',
  components: { BarProgressStepper, NamePage },
  setup() {
    const { steps, step } = useBulkSendStepsProgress();

    const { resetBulkSend } = useActions({
      resetBulkSend: 'bulkSend/resetBulkSend',
    });

    // make sure that we don't have previous bulksend data hanging around
    onBeforeMount(() => {
      resetBulkSend();
    });

    return { steps, step };
  },
});
</script>
